import { List, MessageCircle, FileText } from 'lucide-react'
import { useContentFStore } from '@/stores/useContentFStore'
import { cn } from '@/lib/utils'

export function ContentFMobileNav() {
  const { mobileView, setMobileView } = useContentFStore()

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background border-t border-border safe-area-bottom">
      <div className="flex h-14">
        <NavButton
          icon={List}
          label="Sessions"
          isActive={mobileView === 'sessions'}
          onClick={() => setMobileView('sessions')}
        />
        <NavButton
          icon={MessageCircle}
          label="Chat"
          isActive={mobileView === 'chat'}
          onClick={() => setMobileView('chat')}
        />
        <NavButton
          icon={FileText}
          label="Document"
          isActive={mobileView === 'document'}
          onClick={() => setMobileView('document')}
        />
      </div>
    </nav>
  )
}

interface NavButtonProps {
  icon: React.ComponentType<{ className?: string }>
  label: string
  isActive: boolean
  onClick: () => void
}

function NavButton({ icon: Icon, label, isActive, onClick }: NavButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "flex-1 flex flex-col items-center justify-center gap-1 transition-colors",
        isActive
          ? "text-primary"
          : "text-muted-foreground hover:text-foreground"
      )}
    >
      <Icon className="w-5 h-5" />
      <span className="text-xs">{label}</span>
    </button>
  )
}
